import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const emailContentService = createApi({
  reducerPath: "emailContentService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getEmailWhitelabel: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: `/partner-whitelabel/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Communication Settings",
        },
      }),
    }),
    createEmailWhitelabel: builder.mutation<any, any>({
      query: (body) => ({
        url: `/partner-whitelabel/${body.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Communication Setting",
        },
      }),
    }),
    getMerchantEmailWhitelabel: builder.mutation<any, { merchant_id: number }>({
      query: (params) => ({
        url: `/merchant-whitelabel/${params?.merchant_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Communication Settings",
        },
      }),
    }),
    createMerchantEmailWhitelabel: builder.mutation<any, any>({
      query: (body) => ({
        url: `/merchant-whitelabel/${body.merchant_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Communication Setting",
        },
      }),
    }),
    uploadImage: builder.mutation<any, any>({
      query: (body) => ({
        url: `/info/uploadImage`,
        body: body,
        method: "POST",
        headers: {
          PageName: "Communication Setting",
        },
      }),
    }),
  }),
});

export const {
  useGetEmailWhitelabelMutation,
  useCreateEmailWhitelabelMutation,
  useUploadImageMutation,
  useGetMerchantEmailWhitelabelMutation,
  useCreateMerchantEmailWhitelabelMutation,
} = emailContentService;
